import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { UnavailableRegistration, useModal } from '@libs/components';

import { useTranslation } from 'src/hooks';
import { WebsitePreviewLayout } from 'src/components';
import { CloseReg } from 'src/assets';
import LoginForm from './components/LoginForm';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Dialog, closeModal } = useModal();
  const { colors } = useTheme();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <WebsitePreviewLayout
      heading={t('login_welcome')}
      highlightedHeading={t('login_welcome_highlighted')}
      headerButtonTitle={t('login_register_text')}
      onHeaderButtonClick={handleRegisterClick}
    >
      <LoginForm />
      <Dialog
        title=""
        shouldHideHeaderBorder
        headerBackground={colors.surface.default}
      >
        <UnavailableRegistration
          title={t('unavailable_registration_title')}
          description={t('unavailable_registration_description')}
          buttonTitle={t('common_understandable')}
          imageUrl={CloseReg}
          buttonAction={closeModal}
        />
      </Dialog>
    </WebsitePreviewLayout>
  );
};

export default LoginPage;
